import React, { Component } from 'react';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { requireAll } from 'Utils/requireAll';
import Routes from 'Common/Routes';
import qs from 'query-string';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import Cookies from 'universal-cookie';
import {
  setBetslipFromLocalStorage,
  setLiveScoresFilterFromLocalStorage,
  setCGPlayDataFromLocalStorage,
  setLotteryslipFromLocalStorage,
  setSuperLotteryslipFromLocalStorage,
  updateUserDetails,
  loginSuccess,
  logoutUserLocally,
  logoutUserSuccess,
  openModal,
  closeModal,
  setLotteryRenderType,
  setRaffleRenderer,
  pageView,
  predeactivatedStatusLogin,
  getSocketUrl,
  fetchPredictaBonusCampaign,
  applyUserBalancePayload,
  updateUserBalance,
  refreshToken,
  markPaymentRequestTransactionCompleted,
  getPaymentRequestTransactions,
  loginWithRefreshToken
} from 'Store/actions';
import {
  resetCouponsState
} from 'Store/actions/horseRacing/couponActions';
import { trackPageView } from 'Utils/analytics';
import BetSlip from 'Components/BetSlip';
import ErrorBoundary from 'Components/ErrorBoundary';
import { setAuthToken, removeAuthToken, hasAuthToken, setUniqueDeviceId } from 'Utils/authentication/setAxiosAuthHeader';
import { getUrlParameter } from 'Utils/getUrlParameter';
import { setWebviewModeFlag, isEmbeddedAppShell, isWebviewRenderType } from 'Utils/webviewMode';
import History from 'Store/history';
import metaConfiguration from 'Tools/title-meta-configuration';
import Modal from 'Components/Modal';
import Message from 'Components/Modal/Message';
import Icon from 'Components/Icon';
import ThemeAutoDarkPopup from 'Components/Theme/ThemeAutoDarkPopup';
import EnvironmentManager, { CMS_MESSAGES_READY_EVENT } from 'Utils/environmentManager';
import { getCanonicalArgsFromPathname } from 'Utils/getCanonicalArgsFromPathname';
import { toAbsoluteMediaUrl } from 'Utils/toAbsoluteMediaUrl';
import IndexedDB from 'Utils/indexedDB';
import { withMixpanel } from 'Utils/mixpanel';
import EmailVerification from 'Components/Modal/EmailVerification';
import SuspendedScreen from 'Components/SuspendedScreen';
import VerificationModal from 'Components/Modal/VerificationModal';
import { cmsUpdater } from 'Store/actions';
import MarketingTools from 'Components/MarketingTools';
import HorseRacingBetSlip from 'Components/HorseRacing/HorseRacingBetSlip';
import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import TjkPlayableFlag from 'Components/HorseRacing/TjkPlayableFlag';
import NoSSR from 'Components/NoSSR';
import { withLastLocation } from 'react-router-last-location';
import { doubleDigitDecimalFormatter } from 'Utils/decimalFormatter';
import DrawerWrapper from '../DrawerWrapper';
import { trackCampaignDetails } from '../../../utils/analytics';
import OccupationModal from '../Modal/OccupationModal';
import TrustedDeviceModal from '../Modal/TrustedDeviceModal';
import CmsPolling from '../CmsPolling';
import { subscribeAllTopics } from '../../../utils/webSocketHelper';
import BalanceSSEClient from 'Utils/balanceSSEClient';
import { shouldRefreshBalanceFromSseMessage } from 'Utils/accountBalancePolling';
import {
  isUserLogoutSSEEvent,
  isSseUpstreamUnauthorizedEvent,
  isSuspendedMemberLogoutActive,
  shouldUseSuspendedLogoutOnForceAuthFailure,
  beginSuspendedMemberLogout,
  endSuspendedMemberLogout,
  setSuspendedLogoutNavigateHandler
} from 'Utils/suspendedMemberLogout';
import ToastTemplate from '../ToastTemplate';
import { applyTheme, getUserTheme, initTheme, subscribeSystemTheme, syncThemeWithFeatureFlag, THEME_CHANGE_EVENT, USER_THEME_KEY } from 'Utils/theme';
/** Require svg files which is merge to sprite file. */
requireAll(require.context('Public/images/icons', true, /\.svg$/));

const getMainCmsText = (key, fallback = '') =>
  EnvironmentManager.getMainMessageText({ key }) || fallback;

class App extends Component {
  webSocket = null;
  balanceSSE = null;
  lastSSERefreshAt = 0;
  isRefreshingBalanceToken = false;
  lastKnownBalanceSSEEnabled = null;
  balanceSSEInitVersion = 0;
  balanceBeforeBackground = null;
  isHandlingSuspendedMemberLogout = false;

  syncThemeFromCms = () => {
    syncThemeWithFeatureFlag();
  };

  static propTypes = {
    setBetslipFromLocalStorage: PropTypes.func,
    setLiveScoresFilterFromLocalStorage: PropTypes.func,
    setCGPlayDataFromLocalStorage: PropTypes.func,
    setLotteryslipFromLocalStorage: PropTypes.func,
    setSuperLotteryslipFromLocalStorage: PropTypes.func,
    updateUserDetails: PropTypes.func,
    setLotteryRenderType: PropTypes.func,
    loginSuccess: PropTypes.func,
    setRaffleRenderer: PropTypes.func,
    auth: PropTypes.object,
    userAgent: PropTypes.object,
    showOccupationPopup: PropTypes.bool,
    logoutUserLocally: PropTypes.func,
    logoutUserSuccess: PropTypes.func,
    location: PropTypes.object,
    closeModal: PropTypes.func,
    modalData: PropTypes.object,
    openModal: PropTypes.func,
    history: PropTypes.object,
    mixpanel: PropTypes.object,
    pageView: PropTypes.func,
    cmsUpdater: PropTypes.func,
    predeactivatedStatusLogin: PropTypes.func,
    getSocketUrl: PropTypes.func,
    lastLocation: PropTypes.object,
    fetchPredictaBonusCampaign: PropTypes.func,
    resetCouponsState: PropTypes.func,
    applyUserBalancePayload: PropTypes.func,
    updateUserBalance: PropTypes.func,
    refreshToken: PropTypes.func,
    markPaymentRequestTransactionCompleted: PropTypes.func,
    getPaymentRequestTransactions: PropTypes.func,
    ssrMeta: PropTypes.shape({
      worldCupShareOgImage: PropTypes.string,
      bahistaShareOgImage: PropTypes.string
    }),
  };


  constructor (props) {
    super(props);

    const isEmbeddedShell = isEmbeddedAppShell(props.history?.location?.search || '');

    this.state = {
      renderType: null,
      allChanceGamesPermActive: false,
      isWebviewEntry: isEmbeddedShell,
    };

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {

      if (isEmbeddedShell) {
        setWebviewModeFlag(true);
      }

      props.cmsUpdater();

      const urlAccessToken = getUrlParameter('accessToken');
      const urlRefreshToken = getUrlParameter('refreshToken');

      const hasUrlTokens = !!(urlAccessToken || urlRefreshToken);
      const accessToken = urlAccessToken || (!isEmbeddedShell ? props.auth?.data?.accessToken : null);
      const refreshToken = urlRefreshToken || (!isEmbeddedShell ? props.auth?.data?.refreshToken : null);

      setUniqueDeviceId();
      if (accessToken) {
        setAuthToken(accessToken);
        props.loginSuccess({
          ...props.auth?.data,
          accessToken,
          refreshToken,
        });
      } else if (isEmbeddedShell && !hasUrlTokens) {
        removeAuthToken();
        props.logoutUserSuccess();
      } else if (!isEmbeddedShell && !refreshToken) {
        props.logoutUserSuccess();
      }

      const isBetSlipHidden = document.getElementsByTagName('body')[0]?.classList?.value?.includes('hide-betslip');

      this.state = {
        ...this.state,
        isBetSlipHidden: isBetSlipHidden
      };

      const queryParams = qs.parse(props.history.location?.search);
      if (queryParams?.utm_source)
        sessionStorage.setItem('utm_source', queryParams.utm_source);


    }

  }


  componentDidMount () {
    if (!window?.showMpLiveStreamModal) {
      window.showMpLiveStreamModal = () => {
        this.props.openModal('mpLiveStreamModal');
      };
    }
    if (!this.state.isWebviewEntry) {
      IndexedDB.initialize();
    }
    this.updateViewportForSmallDevices();
    if (!this.state.isWebviewEntry) {
      this.checkNetworkStatus();
    }

    this.setState({
      renderType: getUrlParameter('renderType')
    });

    if (isWebviewRenderType()) {
      this.props.setLotteryRenderType();
      this.props.setRaffleRenderer();
      window.addEventListener('message', this.handleNativeMessage);

      const refreshToken = getUrlParameter('refreshToken');
      if (refreshToken && !this.props.auth?.isAuthenticated) {
        // eslint-disable-next-line react/prop-types
        this.props.loginWithRefreshToken(refreshToken);
      }
    }

    const { isAuthenticated } = this.props.auth;
    if (
      !this.state.isWebviewEntry
      && isAuthenticated
      && this.props.location?.pathname !== '/cikis-yap'
    ) {
      this.props.fetchPredictaBonusCampaign();
      if (!this.isKaziKazanPath(this.props.location?.pathname)) {
        this.initBalanceSSEWhenReady();
      }
    }
    this.lastKnownBalanceSSEEnabled = this.isBalanceSSEEnabled();

    window.addEventListener('beforeunload', this.handlePageCloseForSSE);
    document.addEventListener('visibilitychange', this.handleVisibilityChangeForSSE);
    window.addEventListener('pagehide', this.handlePageHideForSSE);
    window.addEventListener('pageshow', this.handlePageShowForSSE);
    window.addEventListener('storage', this.handleThemeStorageChange);

    initTheme();
    this.unsubscribeSystemTheme = subscribeSystemTheme();
    window.addEventListener(CMS_MESSAGES_READY_EVENT, this.syncThemeFromCms);
    if (EnvironmentManager.isLiveMessagesReady()) {
      this.syncThemeFromCms();
    }

    setSuspendedLogoutNavigateHandler(this.finishSuspendedMemberLogout);

    this.unlisten = History.listen(location => {
      const { isAuthenticated } = this.props.auth;
      const { modalNames: [modalName] } = this.props.modalData;
      window.onpopstate = () => {
        if (isSuspendedMemberLogoutActive() || this.isModalOpen('suspendedMemberLogout')) {
          this.finishSuspendedMemberLogout();
          return;
        }
        if (modalName) {
          this.props.closeModal([]);
        }
      };

      const isTjk = location.pathname.includes('/tjk/');
      if (isTjk) {
        this.openSocketConnection();
      }

      if (location.pathname.includes('sabit-ihtimalli-at-yarisi-bulteni')) {
        const pt = sessionStorage.getItem('pt');
        if (pt && pt === PROGRAM_TYPES.JOINT) {
          const cookies = new Cookies();
          cookies.remove('tjkNavigateParams');
        }
      } else if (location.pathname.includes('at-yarisi-bulteni')) {
        const pt = sessionStorage.getItem('pt');
        if (pt && pt === PROGRAM_TYPES.FIXED) {
          const cookies = new Cookies();
          cookies.remove('tjkNavigateParams');
        }
      }

      if (!location.pathname.includes('at-yarisi-kuponlarim')) {
        this.props.resetCouponsState();
      }
      // hasAuthToken guards stale props.auth after sync logout + History.push.
      if (
        location.pathname === '/'
        && this.props?.location?.pathname !== '/giris-yap'
        && isAuthenticated
        && hasAuthToken()
      ) {
        this.props.updateUserDetails(true);
      }
    });

    if (!this.state.isWebviewEntry) {
      if (location?.search?.includes('utm_source' && 'utm_medium' && 'utm_campaign')) {
        const searchParams = new URLSearchParams(location.search);
        const utm_source = searchParams.get('utm_source');
        const utm_medium = searchParams.get('utm_medium');
        const utm_campaign = searchParams.get('utm_campaign');
        trackCampaignDetails(utm_source, utm_medium, utm_campaign );
      }
      this.trackUTMParams();
    }
  }

  trackUTMParams () {
    const params = {};
    const first_params = {};
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    keys.forEach(key => {
      const value = getUrlParameter(key);
      if (value) {
        params[`${key} [last touch]`] = value;
        first_params[`${key} [first touch]`] = value;
      }
    });

    this.props.mixpanel.people.set(params);
    this.props.mixpanel.people.set_once(first_params);
    this.props.mixpanel.register(params);
  }

  checkNetworkStatus = () => {
    if (typeof window !== 'undefined') {

      window.addEventListener('online', e => {
        this.openSocketConnection().then(r => {
          console.log('Network connection was established.');
        });
      }, false);

      window.addEventListener('offline', e => {
        console.log('Network connection lost.');
        if (this.webSocket) {
          this.webSocket.closeConnection();
        }
      }, false);

    }
  };

  componentDidUpdate (prevProps, prevState) {
    this.syncBalanceSSEWithFeatureFlag();

    // renderType kontrolü değil, "parametre hiç yok" kontrolü — webview için isWebviewRenderType() kullanılır.
    if (prevState.renderType !== this.state.renderType
      && !this.state.renderType.length) {
      this.props.setBetslipFromLocalStorage();
      this.props.setLiveScoresFilterFromLocalStorage();
      this.props.setCGPlayDataFromLocalStorage();
      this.props.setLotteryslipFromLocalStorage();
      this.props.setSuperLotteryslipFromLocalStorage();
      this.openSocketConnection();
    }

    const { isAuthenticated, data } = this.props.auth;

    if (prevProps.auth.isAuthenticated !== isAuthenticated && isAuthenticated) {
      this.props.mixpanel.register({
        Segment: this.props.auth?.data?.segment,
        Balance: this.props.auth?.data?.balance,
        Turkey: this.props.auth?.data?.isVip
      });
      this.props.mixpanel.people.set({
        Segment: this.props.auth?.data?.segment,
        Balance: this.props.auth?.data?.balance,
        Turkey: this.props.auth?.data?.isVip,
        'Ext Cus ID': this.props.auth?.data?.externalCustomerId
      });
    }

    if (prevProps.auth.data?.isReadLatestPolicy !== data?.isReadLatestPolicy
      && data?.isReadLatestPolicy === false) {
      this.props.openModal('KVKKModal');
    }

    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      this.syncBalanceSSEWithRoute(prevProps.location?.pathname);
    }

    if (prevProps.auth.isAuthenticated !== isAuthenticated) {
      if (isAuthenticated && !this.isBalanceSseBlockedByPage()) {
        this.initBalanceSSEWhenReady();
      } else {
        this.disconnectBalanceSSE();
      }
    }

    if (
      prevProps.auth.isAuthenticated
      && isAuthenticated
      && prevProps.auth.data?.accessToken !== data?.accessToken
      && data?.accessToken
    ) {
      if (this.isBalanceSSEEnabled() && !this.isBalanceSseBlockedByPage()) {
        this.reconnectBalanceSSE();
      }
    }
  }

  handleNativeMessage = event => {
    try {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (data?.type === 'logout') {
        // Mobile webview flow keeps auth state in app shell; do not force web logout.
        if (!this.state.isWebviewEntry) {
          this.props.logoutUserSuccess();
        }
      }
    } catch (e) {
      // ignore unparseable messages
    }
  };

  handleThemeStorageChange = event => {
    if (event.key === USER_THEME_KEY || event.key === null) {
      applyTheme(getUserTheme());
      try {
        window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, {
          detail: { theme: getUserTheme() }
        }));
      } catch (e) {
        // ignore
      }
    }
  };

  componentWillUnmount () {
    window.removeEventListener('storage', this.handleThemeStorageChange);
    this.unsubscribeSystemTheme?.();
    window.removeEventListener(CMS_MESSAGES_READY_EVENT, this.syncThemeFromCms);
    window.removeEventListener('beforeunload', this.handlePageCloseForSSE);
    document.removeEventListener('visibilitychange', this.handleVisibilityChangeForSSE);
    window.removeEventListener('pagehide', this.handlePageHideForSSE);
    window.removeEventListener('pageshow', this.handlePageShowForSSE);
    if (this.webSocket)
      this.webSocket.closeConnection();
    this.disconnectBalanceSSE();
    setSuspendedLogoutNavigateHandler(null);
    endSuspendedMemberLogout();
    window.removeEventListener('message', this.handleNativeMessage);
  }

  isBalanceSSEEnabled = () => {
    return EnvironmentManager.getParameter('user_sse_enabled_web') === true;
  };

  isKaziKazanPath = pathname => {
    return pathname === '/kazi-kazan' || (typeof pathname === 'string' && pathname.startsWith('/kazi-kazan/'));
  };

  isBalanceSseBlockedByPage = () => {
    const pathname = this.props.location?.pathname;
    return pathname === '/cikis-yap' || this.isKaziKazanPath(pathname);
  };

  syncBalanceSSEWithRoute = prevPathname => {
    const wasBlocked = prevPathname === '/cikis-yap' || this.isKaziKazanPath(prevPathname);
    const isBlocked = this.isBalanceSseBlockedByPage();
    if (wasBlocked === isBlocked) return;

    if (isBlocked) {
      this.disconnectBalanceSSE();
      return;
    }

    if (this.props.auth?.isAuthenticated && this.isBalanceSSEEnabled()) {
      this.initBalanceSSEWhenReady();
    }
  };

  syncBalanceSSEWithFeatureFlag = () => {
    try {
      const isEnabled = this.isBalanceSSEEnabled();
      if (this.lastKnownBalanceSSEEnabled === null) {
        this.lastKnownBalanceSSEEnabled = isEnabled;
        return;
      }

      if (this.lastKnownBalanceSSEEnabled === isEnabled) return;
      this.lastKnownBalanceSSEEnabled = isEnabled;

      if (!isEnabled) {
        this.disconnectBalanceSSE();
        return;
      }

      const isAuthenticated = this.props.auth?.isAuthenticated;
      if (isAuthenticated && !this.isBalanceSseBlockedByPage()) {
        this.initBalanceSSEWhenReady();
      }
    } catch (e) {
      // no-op: non-critical SSE feature.
    }
  };

  initBalanceSSEWhenReady = async () => {
    try {
      const initVersion = ++this.balanceSSEInitVersion;
      await EnvironmentManager.waitForMessages();
      if (initVersion !== this.balanceSSEInitVersion) return;

      const isAuthenticated = this.props.auth?.isAuthenticated;
      if (!isAuthenticated || this.isBalanceSseBlockedByPage()) return;
      if (!this.isBalanceSSEEnabled()) return;

      this.connectBalanceSSE();
    } catch (e) {
      // no-op
    }
  };

  handlePageCloseForSSE = () => {
    this.disconnectBalanceSSE();
  };

  isMobileWebForBalanceSSE = () => {
    const isMobile = this.props.userAgent?.device?.type === 'mobile';
    return isMobile && !isWebviewRenderType();
  };

  disconnectBalanceSSEForBackground = () => {
    if (typeof document === 'undefined') return;
    if (!this.isMobileWebForBalanceSSE()) return;
    if (document.visibilityState !== 'hidden') return;

    const isAuthenticated = this.props.auth?.isAuthenticated;
    const isLogoutPage = this.props.location?.pathname === '/cikis-yap';

    if (isAuthenticated && !isLogoutPage) {
      this.balanceBeforeBackground = this.props.auth?.data?.balance ?? null;
      this.disconnectBalanceSSE();
    }
  };

  resumeBalanceSSEAfterForeground = async () => {
    if (!this.isMobileWebForBalanceSSE()) return;

    const isAuthenticated = this.props.auth?.isAuthenticated;
    if (!isAuthenticated || this.isBalanceSseBlockedByPage() || !this.isBalanceSSEEnabled()) return;

    const prevBalance = this.balanceBeforeBackground;

    this.connectBalanceSSE();
    this.reconcilePaymentRequestTransactions();

    try {
      const balanceData = await this.props.updateUserBalance();
      this.showDepositToastOnForegroundResume(prevBalance, balanceData?.balance);
    } catch (e) {
      // non-critical
    }
  };

  showDepositToastOnForegroundResume = (prevBalance, newBalance) => {
    try {
      if (prevBalance === null || prevBalance === undefined) return;
      if (newBalance === null || newBalance === undefined) return;

      const prev = Number(prevBalance);
      const next = Number(newBalance);
      if (!Number.isFinite(prev) || !Number.isFinite(next)) return;

      const diff = next - prev;
      if (diff <= 0) return;

      const amount = `${doubleDigitDecimalFormatter(diff)} ₺`;
      const toastId = `incoming-deposit-foreground-${Date.now()}`;
      toast(
        <ToastTemplate type="success">
          { `Hesabınıza ${amount} geldi.` }
        </ToastTemplate>,
        {
          toastId,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        }
      );
    } catch (e) {
      // non-critical
    } finally {
      this.balanceBeforeBackground = null;
    }
  };

  reconcilePaymentRequestTransactions = async () => {
    try {
      // eslint-disable-next-line react/prop-types
      const prevData = this.props.paymentRequest?.data || [];
      const hadWaiting = prevData.some(
        tx => (tx.status || '').toUpperCase() === 'WAITING'
      );
      if (!hadWaiting) return;

      await this.props.getPaymentRequestTransactions({
        dateFilter: 'ALL',
        statusFilter: 'ALL',
        page: 0,
        size: 3
      });
    } catch (e) {
      // non-critical: SSE will eventually deliver updates
    }
  };

  handleVisibilityChangeForSSE = () => {
    if (typeof document === 'undefined') return;
    if (!this.isMobileWebForBalanceSSE()) return;

    if (document.visibilityState === 'hidden') {
      this.disconnectBalanceSSEForBackground();
      return;
    }

    this.resumeBalanceSSEAfterForeground();
  };

  handlePageHideForSSE = () => {
    this.disconnectBalanceSSEForBackground();
  };

  handlePageShowForSSE = () => {
    this.resumeBalanceSSEAfterForeground();
  };

  connectBalanceSSE = () => {
    try {
      const enabled = this.isBalanceSSEEnabled();
      if (!enabled || this.isBalanceSseBlockedByPage()) return;
      const token = this.props.auth?.data?.accessToken;
      if (!token || typeof window === 'undefined') return;

      if (!this.balanceSSE) {
        this.balanceSSE = new BalanceSSEClient({
          onMessage: this.handleBalanceSSEMessage,
          onError: this.handleBalanceSSEError
        });
      }

      this.balanceSSE.connect(token);
    } catch (e) {
      // no-op
    }
  };

  reconnectBalanceSSE = token => {
    try {
      if (this.isBalanceSseBlockedByPage()) return;
      if (!this.balanceSSE) {
        this.connectBalanceSSE();
        return;
      }
      this.balanceSSE.reconnect(token || this.props.auth?.data?.accessToken);
    } catch (e) {
      // no-op
    }
  };

  disconnectBalanceSSE = () => {
    try {
      this.balanceSSEInitVersion += 1;
      if (this.balanceSSE) {
        this.balanceSSE.disconnect();
      }
    } catch (e) {
      // no-op
    }
  };

  handleSuspendedMemberLogout = () => {
    try {
      if (this.isHandlingSuspendedMemberLogout || this.isModalOpen('suspendedMemberLogout')) return;

      this.isHandlingSuspendedMemberLogout = true;
      this.disconnectBalanceSSE();
      beginSuspendedMemberLogout({
        openModal: this.props.openModal
      });
    } catch (e) {
      this.isHandlingSuspendedMemberLogout = false;
      endSuspendedMemberLogout();
    }
  };

  finishSuspendedMemberLogout = () => {
    if (!this.isHandlingSuspendedMemberLogout && !this.isModalOpen('suspendedMemberLogout') && !isSuspendedMemberLogoutActive()) {
      return;
    }
    this.isHandlingSuspendedMemberLogout = false;
    endSuspendedMemberLogout();
    this.props.closeModal('suspendedMemberLogout');
    this.props.logoutUserLocally();
    if (typeof window !== 'undefined') {
      window.location.replace('/');
    }
  };

  handleBalanceSSEMessage = message => {
    try {
      const enabled = this.isBalanceSSEEnabled();
      if (!enabled || this.isBalanceSseBlockedByPage()) return;

      if (isUserLogoutSSEEvent(message) || isSseUpstreamUnauthorizedEvent(message)) {
        this.handleSuspendedMemberLogout();
        return;
      }

      const parseMaybeJSON = value => {
        if (!value || typeof value !== 'string') return null;
        try {
          return JSON.parse(value);
        } catch (e) {
          return null;
        }
      };

      const basePayload = message?.d || message;
      if (!basePayload) return;

      const rawCandidates = [
        basePayload,
        basePayload?.data,
        basePayload?.payload,
        basePayload?.body,
        basePayload?.value,
        message?.data,
        message?.payload,
        message?.body
      ].filter(Boolean);

      const candidates = rawCandidates
        .flatMap(candidate => {
          if (candidate && typeof candidate === 'object') return [candidate];
          const parsed = parseMaybeJSON(candidate);
          return parsed && typeof parsed === 'object' ? [parsed] : [];
        });

      const payload = candidates.find(candidate =>
        Object.prototype.hasOwnProperty.call(candidate, 'balance')
        || Object.prototype.hasOwnProperty.call(candidate, 'amountInfoList')
        || Object.prototype.hasOwnProperty.call(candidate, 'digitalGamesBalance')
        || Object.prototype.hasOwnProperty.call(candidate, 'availableTopWinPoint')
      );

      const transactionPayload = candidates.find(candidate =>
        Object.prototype.hasOwnProperty.call(candidate, 'lastTransactionId')
      );
      const lastTransactionId = transactionPayload?.lastTransactionId;
      if (lastTransactionId !== null && typeof lastTransactionId !== 'undefined' && lastTransactionId !== '') {
        this.props.markPaymentRequestTransactionCompleted(lastTransactionId);
      }
      const incomingDepositPayload = {
        ...(payload || {}),
        ...(transactionPayload || {}),
        eventId: message?.id,
        eventTime: message?.et || message?.pt
      };
      this.showIncomingBankDepositToast(incomingDepositPayload);

      if (payload) {
        this.props.applyUserBalancePayload(payload, 'sse');
        return;
      }

      if (shouldRefreshBalanceFromSseMessage(message)) {
        this.refreshBalanceFromSSE();
      }
    } catch (e) {
      // no-op
    }
  };

  showIncomingBankDepositToast = transactionPayload => {
    try {
      if (!transactionPayload) return;

      if (transactionPayload.notification !== true) return;

      const transferAmount = Number(
        transactionPayload.transferAmount ?? transactionPayload.amount
      );
      if (!Number.isFinite(transferAmount) || transferAmount <= 0) return;

      const amount = `${doubleDigitDecimalFormatter(transferAmount)} ₺`;
      const eventId = transactionPayload?.eventId;
      const eventTime = transactionPayload?.eventTime;
      const lastTransactionId = transactionPayload?.lastTransactionId;
      // eslint-disable-next-line no-nested-ternary
      const toastId = lastTransactionId
        ? `incoming-deposit-${lastTransactionId}`
        : (eventId
          ? `incoming-deposit-${eventId}`
          : `incoming-deposit-${eventTime || Date.now()}-${transferAmount}`);

      toast(
        <ToastTemplate type="success">
          { `Hesabınıza ${amount} geldi.` }
        </ToastTemplate>,
        {
          toastId,
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        }
      );
    } catch (e) {
      // no-op
    }
  };

  handleBalanceSSEError = async (error, meta = {}) => {
    try {
      if (meta?.isTransient) return;

      if (meta?.status === 401) {
        if (this.isRefreshingBalanceToken) return;
        this.isRefreshingBalanceToken = true;
        this.disconnectBalanceSSE();

        try {
          const refreshed = await this.props.refreshToken();
          const refreshedAccessToken = refreshed?.accessToken;
          const isAuthenticated = this.props.auth?.isAuthenticated;

          if (refreshedAccessToken && isAuthenticated && !this.isBalanceSseBlockedByPage() && this.isBalanceSSEEnabled()) {
            this.reconnectBalanceSSE(refreshedAccessToken);
          }
        } catch (refreshError) {
          // The token behind the SSE connection was rejected (401) and the silent
          // refresh above also failed - this happens when the session/token was
          // force-invalidated server-side (e.g. customerId token invalidate).
          // Previously this error was swallowed here, leaving the SSE channel
          // disconnected with no reconnect and no user-facing feedback: the
          // suspended-logout popup only appeared after a manual page reload
          // (which goes through the REST 401 interceptor instead). Surface the
          // same forced-logout flow directly so the live path matches reload.
          if (isSuspendedMemberLogoutActive() || shouldUseSuspendedLogoutOnForceAuthFailure(this.props.auth)) {
            this.handleSuspendedMemberLogout();
          }
        } finally {
          this.isRefreshingBalanceToken = false;
        }
      }
    } catch (e) {
      this.isRefreshingBalanceToken = false;
    }
  };

  refreshBalanceFromSSE = () => {
    try {
      const now = Date.now();
      // Avoid flooding account-balance endpoint for bursty SSE messages.
      if (now - this.lastSSERefreshAt < 1500) return;

      const isVisible = document?.visibilityState !== 'hidden';
      const { isAuthenticated } = this.props.auth || {};

      if (!isAuthenticated || !isVisible || this.isBalanceSseBlockedByPage()) return;
      this.lastSSERefreshAt = now;
      this.props.updateUserBalance();
    } catch (e) {
      // no-op
    }
  };

  openSocketConnection = async () => {
    try {
      const socketUrl = await getSocketUrl();
      const module = await import('Utils/webSocketInstance');

      this.webSocket = module.default;

      this.webSocket.openConnection(socketUrl);

      subscribeAllTopics(this.webSocket);

      const isTjk = this.props.location.pathname.includes('/tjk/');
      if (isTjk) {
        this.webSocket.sendMessage({
          kind: 'SubscribeStreamTopic',
          topic: 'tjk_propositions'
        });
      }
    } catch (e) {
      console.error("Can't import websocket dynamically.", e);
    }
  };

  updateViewportForSmallDevices = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const screenWidth = window.innerWidth;

      if (screenWidth < 375) {
        const viewport = document.querySelector('meta[name=viewport]');
        viewport.setAttribute('content', 'width=device-width, initial-scale=.8, maximum-scale=.8, user-scalable=0');
      }
    }
  };

  isModalOpen = modalNameRequest => {
    const { modalNames } = this.props.modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };


  getActiveModalContent = () => {
    if (this.isModalOpen('changePasswordModal')) {
      return (
        <Modal onClose={ () => {
          this.props.closeModal('changePasswordModal');
        } }
        buttonArea={ {
          primaryButton: {
            label: 'DEVAM ET',
            onClick: () => {
              this.props.closeModal('changePasswordModal');
              const referenceCode = this.props.modalData?.changePasswordModal?.referenceCode;
              const identifier = this.props.modalData?.changePasswordModal?.identifier;
              if (referenceCode) {
                History.push(`/sifremi-unuttum?referans-kod=${referenceCode}`, {
                  identifier: identifier,
                  referenceCode: referenceCode
                });
              } else {
                History.push('/sifremi-unuttum');
              }
            }
          }
        } }
        >
          <Message type="none">
            <span>
              { EnvironmentManager.getMessageText({ key: 'alphanumeric_password_info' }) }
            </span>
          </Message>
        </Modal>
      );
    } else if (this.isModalOpen('predeactivatedStatusLogin')) {
      return (
        <Modal onClose={ () => {
          this.props.closeModal('predeactivatedStatusLogin');
        } }
        buttonArea={ {
          primaryButton: {
            label: 'DEVAM ET',
            onClick: () => {
              const { username, password } = this.props.modalData.predeactivatedStatusLogin.formData;
              this.props.predeactivatedStatusLogin(username, password);
              this.props.closeModal('predeactivatedStatusLogin');
              this.props.openModal('changePasswordModal');
            }
          }
        } }
        >
          <Message type="none">
            <span>
              { EnvironmentManager.getMessageText({ key: 'password_login_reset_kvkk_popup' }) }
            </span>
          </Message>
        </Modal>
      );

    } else if (this.isModalOpen('chanceGamesPermissionModal')) {
      const displayNumber = EnvironmentManager.getMessageText({ key: 'callcentercallme_display_number' }) || '0850 272 0 272';
      const here = EnvironmentManager.getMessageText({ key: 'digital_games_buradan_permission' }) || 'buradan';
      const callNumber = EnvironmentManager.getMessageText({ key: 'callcentercallme_call_number' }) || '+908502720272';
      const allGamesNoEntry = EnvironmentManager.getMessageText({ key: 'description_all_games_no_entry' }) || 'Şans oyunlarına girişiniz talebiniz üzerine kapatılmıştır. Tercihinizi değiştirmek isterseniz, Bilyoner Müşteri Hizmetlerini %@ arayabilir ya da %@ talebinizi iletebilirsiniz.';
      const gameNoEntry = EnvironmentManager.getMessageText({ key: 'description_game_no_entry' }) || 'Oyuna girişiniz talebiniz üzerine kapatılmıştır. Tercihinizi değiştirmek isterseniz, Bilyoner Müşteri Hizmetlerini %@ arayabilir ya da %@ talebinizi iletebilirsiniz.';
      const allMesageTextArr = allGamesNoEntry.split('%@');
      const gameMessageTextArr = gameNoEntry.split('%@');


      return (
        <Modal
          title={ EnvironmentManager.getMessageText({ key: 'description_games_no_entry_header' }) || 'İşlem Gerçekleşmedi' }
          onClose={ () => this.props.closeModal('chanceGamesPermissionModal') }
          iconName="svgInfoCircleGreen"
          buttonArea={ {
            primaryButton: {
              label: EnvironmentManager.getMessageText({ key: 'description_games_no_entry_button' }) || 'Tamam',
              onClick: () => this.props.closeModal('chanceGamesPermissionModal'),
            }
          } }
        >

          <Message type="none">
            { this.props.auth?.data?.digitalGamesPermissions?.preferences?.every(c => c.status) ? (<>
              { allMesageTextArr[0] }
              <a className='drawer-green-link' href={ `tel:${callNumber}` }>
                { `(${displayNumber}) ` }
              </a>
              { allMesageTextArr[1] }
              <span className='drawer-green-link' onClick={ () => {
                this.props.closeModal('chanceGamesPermissionModal');
                History.push('/yardim/bize-yazin');
              } }>{ here }</span>
              { allMesageTextArr[2] }
            </>) : (
              <>
                { gameMessageTextArr[0] }
                <a className='drawer-green-link' href={ `tel:${callNumber}` }>
                  { `(${displayNumber}) ` }
                </a>
                { gameMessageTextArr[1] }
                <span className='drawer-green-link' onClick={ () => {
                  this.props.closeModal('chanceGamesPermissionModal');
                  History.push('/yardim/bize-yazin');
                } }>{ here }</span>
                { gameMessageTextArr[2] }
              </>) }
          </Message>
        </Modal>
      );
    } else if (this.isModalOpen('suspendedMemberLogout') || isSuspendedMemberLogoutActive()) {
      return (
        <Modal
          centered
          position={ { web: 'center', mobile: 'bottom' } }
          closeIconVisible={ false }
          disableOverlayClick={ true }
          className="suspended-member-logout-modal"
          onClose={ this.finishSuspendedMemberLogout }
          buttonArea={ {
            primaryButton: {
              label: getMainCmsText('suspended_member_logout_button', 'Ana Sayfaya Dön'),
              onClick: this.finishSuspendedMemberLogout
            }
          } }
        >
          <div className="suspended-member-logout-modal__content">
            <div className="suspended-member-logout-modal__icon-wrap">
              <Icon className="suspended-member-logout-modal__icon" iconName="svgInfoOutlineV2" />
            </div>
            <h2 className="suspended-member-logout-modal__title">
              { getMainCmsText('suspended_member_logout_title', 'Oyun Oturumunuz Sonlandırıldı') }
            </h2>
            <p className="suspended-member-logout-modal__text">
              { getMainCmsText(
                'suspended_member_logout_text',
                'Güvenlik nedeniyle oyun oturumunuz sonlandırılmıştır. Devam etmek için ana sayfaya dönebilirsiniz.'
              ) }
            </p>
          </div>
        </Modal>
      );
    }
  };

  render () {
    const { location: { pathname } } = this.props;
    let title = metaConfiguration[pathname]?.title;
    let description = metaConfiguration[pathname]?.description;
    let meta = metaConfiguration[pathname]?.meta || [];
    const modalContent = this.getActiveModalContent();

    if (!title) {
      // exact url is not found on meta-title configuration so we should search for the right pattern to find the matching one
      const metaKeys = Object.keys(metaConfiguration);
      let matchingKey = metaKeys.find(meta => meta.includes(pathname.match(/(^\/[aA-zZ/-]*)(?=\d+\/?)*/)?.[0].slice(0, -1)));

      if (!matchingKey) {
        matchingKey = metaKeys.find(meta => meta.includes(pathname.match(/\/[\w-]*\//)?.[0].slice(0, -1)));
      }

      title = metaConfiguration[matchingKey]?.title;
      description = metaConfiguration[matchingKey]?.description;
      meta = metaConfiguration[matchingKey]?.meta || [];

      if (pathname.includes(TJK_URL_SUFFIX.program.fullPage)) {
        title = 'At Yarışı Bülteni & Programı | Bilyoner';
        description = 'At yarışı bülteni ve programıyla kazanmaya bir adım daha yaklaş! Bahis yap, Bilyoner’in bülteninde günün koşularını ve at yarışı analizlerini keşfet';
      } else if (pathname.includes(TJK_URL_SUFFIX.result.fullPage)) {
        title = 'Tt Yarışı Sonuçları & Kazananlar | Bilyoner';
        description = 'Günün en kazandıran kuponları ve at yarışı sonuçları Bilyoner’de! Tüm resmi sonuçları, istatistikleri ve analizleri görmek için hemen tıklayın.';
      } else if (pathname.includes(TJK_URL_SUFFIX.agf.fullPage)) {
        title = 'AGF Tablosu | Bilyoner';
        description = 'En güncel, anlık takip edebileceğiniz AGF tablosu Bilyoner’de! En çok oynanan altılı ganyan favorisi atları incelemek, detaylı istatistiki bilgi almak için tıklayın!';
      } else if (pathname.includes(TJK_URL_SUFFIX.author.fullPage)) {
        title = 'At Yarışı Yorumları, Tahminleri & Hazır Kuponlar | Bilyoner';
        description = 'At Yarışı yorum ve tahminleri Bilyoner’de! Çok kazandıran hazır kuponlara, at yarışı detaylı yazar yorumlarına ve tüyolarına ulaşmak için hemen tıklayın!';
      } else if (pathname.includes(TJK_URL_SUFFIX.horseCard.fullPage)) {
        title = 'At Detay | Bilyoner';
        description = 'Bilyoner’de atların tüm bilgilerini inceleyin! At detay sayfasında performans geçmişi, koşu istatistikleri ve daha fazlasını keşfedin.';
      }
    }

    const canonicalArgs = getCanonicalArgsFromPathname(this.props);

    const isWorldCupNostalgia = pathname === '/dunya-kupasi-nostalji';
    const isBahistaMatchCard = pathname.includes('/mac-karti/') && (/bahista/i).test(pathname);
    const cmsWorldCupShareRaw = isWorldCupNostalgia
      ? EnvironmentManager.getMessageText({ key: 'world_cup_history_share_picture' })
      : '';
    const worldCupOgHydrated = cmsWorldCupShareRaw ? toAbsoluteMediaUrl(cmsWorldCupShareRaw) : '';
    const worldCupOgSsr = this.props.ssrMeta?.worldCupShareOgImage || '';
    const worldCupShareOgImage = isWorldCupNostalgia ? (worldCupOgHydrated || worldCupOgSsr) : '';
    const cmsBahistaShareRaw = isBahistaMatchCard
      ? EnvironmentManager.getMessageText({ key: 'match_card_bahista_share_image' })
      : '';
    const bahistaOgHydrated = cmsBahistaShareRaw ? toAbsoluteMediaUrl(cmsBahistaShareRaw) : '';
    const bahistaOgSsr = this.props.ssrMeta?.bahistaShareOgImage || '';
    const bahistaShareOgImage = isBahistaMatchCard ? (bahistaOgHydrated || bahistaOgSsr) : '';
    const shareOgImage = worldCupShareOgImage || bahistaShareOgImage;
    const twitterCard = shareOgImage ? 'summary_large_image' : 'summary';

    const appConfig = {
      htmlAttributes: {
        lang: 'tr'
      },
      title: isBahistaMatchCard ? undefined : (title || 'Bilyoner.com - İddaa | Spor Toto | Milli Piyango'),
      meta: [
        {
          name: 'color',
          content: '#007738'
        },
        ...(isBahistaMatchCard ? [] : [{
          name: 'description',
          content: description || 'İddaa Bilyoner.com’da oynanır! Kazandıran tahminler, banko kuponlar, iddaa programı, maç sonuçları ve canlı maç yayını ile Bilyoner.com’da şans her an yanınızda.'
        }]),
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'Bilyoner' },
        { property: 'og:url', content: canonicalArgs?.href },
        ...(isBahistaMatchCard ? [] : [
          { property: 'og:title', content: title },
          { property: 'og:description', content: description || 'İddaa Bilyoner.com’da oynanır! Kazandıran tahminler, banko kuponlar, iddaa programı, maç sonuçları ve canlı maç yayını ile Bilyoner.com’da şans her an yanınızda.' },
        ]),
        { property: 'og:image', content: shareOgImage },
        { name: 'twitter:card', content: twitterCard },
        ...(shareOgImage ? [{ name: 'twitter:image', content: shareOgImage }] : []),
        { name: 'twitter:site', content: '@bilyoner' },
        ...meta
      ],
      link: [
        canonicalArgs
      ]
    };

    return (
      <ErrorBoundary>
        <MarketingTools deferred={ this.state.isWebviewEntry } />
        { !this.state.isWebviewEntry && <CmsPolling /> }
        <Helmet { ...appConfig } onChangeClientState={ this.onHelmetChange } />
        { renderRoutes(Routes, {
          userAgent: this.props.userAgent,
          metaConfiguration: metaConfiguration
        }) }

        { (pathname.includes('tjk/at-yarisi-bulteni') || pathname.includes('tjk/sabit-ihtimalli-at-yarisi-bulteni')) ? (
          <NoSSR>
            <TjkPlayableFlag>
              { this?.props?.userAgent?.device?.type !== 'desktop' && <HorseRacingBetSlip/> }
            </TjkPlayableFlag>
          </NoSSR>
        ) : (
          <BetSlip isBetSlipHidden={ this.state.isBetSlipHidden } userAgent={ this.props.userAgent } />
        ) }
        <OccupationModal />
        { modalContent }
        <EmailVerification />
        <SuspendedScreen />
        <VerificationModal />
        <DrawerWrapper />
        <TrustedDeviceModal />
        { !this.state.isWebviewEntry && <ThemeAutoDarkPopup /> }
        <Modal modalSize="large" title="Canlı İzle" centered buttonArea={ {
          secondaryButton: {
            onClick: () => this.props.closeModal('mpLiveStreamModal'),
            label: 'KAPAT',
          }
        } } onClose={ ()=> this.props.closeModal('mpLiveStreamModal') } isOpen={ this.isModalOpen('mpLiveStreamModal') }>

          <div className="mp-live-stream-area">
            <iframe allow="autoplay" src={ EnvironmentManager.getMessageText({ key: 'v1.nationallottery.live_stream' }) } />
          </div>

        </Modal>
      </ErrorBoundary>
    );
  }

  onHelmetChange = (newState, addedTags, removedTags) => {
    const pathname = window?.location?.pathname;

    trackPageView(newState.title?.replace('Bilyoner.com | ', ''), pathname);

    const isBetSlipHidden = document.getElementsByTagName('body')[0]?.classList?.value?.includes('hide-betslip');
    this.setState({
      isBetSlipHidden: isBetSlipHidden
    });

    if (typeof window !== 'undefined') {
      this.props.pageView(newState.title, pathname);
    }
    if (!this.state.isWebviewEntry && window.efilliSdk) {
      window.efilliSdk.init();
    }
    if (this.props?.location?.pathname.includes('cerez-ayarlari')) {
      this.props.history.replace('/', {  lastLocationUrl: this.props?.location.pathname });
      setTimeout(() => {
        document.getElementsByClassName('efl-edit')?.[1]?.click();
      }, 500);

    }
    if (this.props?.location?.pathname.includes('euro2024')) {
      this.props.history.replace('/', {  lastLocationUrl: this.props?.location.pathname });
    }


  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  userAgent: state.userAgent,
  modalData: state.modalData,
  showOccupationPopup: state.drawer.showOccupationPopup,
  paymentRequest: state.paymentRequest,
  ssrMeta: state.ssrMeta
});

export default withRouter(connect(
  mapStateToProps,
  {
    setLotteryRenderType,
    setRaffleRenderer,
    setBetslipFromLocalStorage,
    setLiveScoresFilterFromLocalStorage,
    setCGPlayDataFromLocalStorage,
    setLotteryslipFromLocalStorage,
    setSuperLotteryslipFromLocalStorage,
    loginSuccess,
    logoutUserLocally,
    logoutUserSuccess,
    loginWithRefreshToken,
    updateUserDetails,
    closeModal,
    openModal,
    pageView,
    cmsUpdater,
    predeactivatedStatusLogin,
    getSocketUrl,
    fetchPredictaBonusCampaign,
    resetCouponsState,
    applyUserBalancePayload,
    updateUserBalance,
    refreshToken,
    markPaymentRequestTransactionCompleted,
    getPaymentRequestTransactions
  })(withMixpanel(withLastLocation(App))));
